import { CrmLeadSource } from "@enums/crmLeadSource.enum";
import { CrmOpportunityStage } from "@enums/crmOpportunityStage.enum";
import { Model } from "@interfaces/model.interface";

export interface CrmOpportunity extends Model {
	actualCloseDate?: Date;
	assignedUserId?: number;
	clientId?: number;
	crmContactId?: number;
	crmLeadId?: number;
	expectedCloseDate?: Date;
	isSensitive: boolean;
	notes: string;
	source?: CrmLeadSource;
	stage: CrmOpportunityStage;
	title: string;
	value: number;
}

export class CrmOpportunity implements CrmOpportunity {

	constructor(data?: Partial<CrmOpportunity>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
